import './App.css';
import { Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import CanvaPage from './pages/CanvaPage';
import HikvisionPage from './pages/HikvisionPage';

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/canva" element={<CanvaPage />} />
        <Route path="/Hikvision" element={<HikvisionPage />} />
      </Routes>
    </div>
  );
}

export default App;
